(function () {
    'use strict';

    var mod = angular.module('uwAgenda.settings.agendasettings');
    mod.directive('sharedAgendaRow', [
        '$translate', 
        'RightConfigurationService', 
        'Alert', 
        'UserSearchService', 
        'SharedAgendaService',
        'HelperService',
        '$stateParams',
         SharedAgendaRowFn
    ]);

    /* shared agenda table row directive */
    function SharedAgendaRowFn(
        $translate, 
        RightConfigurationService, 
        Alert, 
        UserSearchService, 
        SharedAgendaService,
        HelperService,
        $stateParams) {

        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/sharedagendas/templates/shared-agenda-row.template.html'
        };
        return directive;

        function link(scope, element, attrs) {
            // if editing -> this is the original backup
            var original = null;

            activate();
            
            scope.validDate = dateTimeStr => {
                if (!dateTimeStr) { return false; }

                let unknownDate = new Date('0001-01-01T00:00:00');
                let date = new Date(dateTimeStr);
                if (date.getTime() === unknownDate.getTime()) { return false; }
                
                return true;
            };
            
            scope.formatDate = dateTimeStr => {
                let date = new Date(dateTimeStr);
                return moment(date).format("DD/MM/YYYY HH:mm:ss");
            }

            // search users with groupPracticeSearch
            scope.searchUser = function (searchValue) {
                return UserSearchService.groupPracticeSearch(searchValue).then(function (result) {
                    return removeExistingUsers(result);
                });
            };

            // cancel editing -> show original
            scope.cancel = function () {
                if (original === null) {
                    scope.vm.overview.remove(scope.item.vmIndex);
                }
                else {
                    // replace original with current edited item
                    scope.vm.overview.replace(original, scope.item.vmIndex);
                    // remove backup
                    original = null;
                } // else
            };

            // deactivate item (remove from table if it is new)
            scope.deactivate = function () {
                if (scope.item.vmNew) {
                    scope.vm.overview.deactivate(scope.item, scope.item.vmIndex);
                } else {
                    var confirmationModal = HelperService.deactivatingConfirmationModal();
                    confirmationModal.result.then(function() {                        
                        RightConfigurationService.deleteRight(scope.item.id, SharedAgendaService.currentUser().id).then(function (result) {
                            Alert.success($translate.instant('shared_agenda_removed'));
                            scope.vm.overview.remove(scope.item.vmIndex);
                            refreshReleasedAgendas();
                        });                        
                    });

                }
            };

            scope.changeActiveStatus = () => {
                let item = scope.item;
                let currentUserId = SharedAgendaService.currentUser().id;
                let originalActive = item.active;
                original = item;
                RightConfigurationService.updateActive(item.id, currentUserId, item.active).then(result => {
                    scope.vm.overview.save(scope.item);

                    // save states options 
                    let isOptionChangeAllowed = scope.item.isOptionChangeAllowed;
                    let isStateChangeAllowed = scope.item.isStateChangeAllowed;

                    // replace current with edited one
                    scope.item.extend(result);
                    scope.item.isOptionChangeAllowed = isOptionChangeAllowed;
                    scope.item.isStateChangeAllowed = isStateChangeAllowed;

                    Alert.success($translate.instant('shared_agenda_rights_saved'));
                },
                function (error) {
                    original.active = originalActive;
                    scope.cancel();
                });
            };

            // save editing values
            scope.save = function () {
                if (typeof scope.item.userDto !== "object" || !scope.item.userDto.id || scope.item.id > 0) {
                    return;
                }

                return RightConfigurationService.save(SharedAgendaService.currentUser().id, scope.item.userDto.id, scope.item.fK_Agenda, true, scope.item.fK_User_Initiator).then(function (result) {
                    scope.vm.overview.save(scope.item);
                    refreshReleasedAgendas();

                    Alert.success($translate.instant('shared_agenda_rights_saved'));
                });
            }
            
            function activate() {
               
            }

            // only users whitout any shared-agenda-settings will be shown
            function removeExistingUsers(users) {
                var currentAgendaId = SharedAgendaService.currentUser().agendaId;

                // only return users that don't have a shared-agenda configuration yet
                scope.vm.sharedAgendaDto.sharedAgendas.forEach(function (sharedAgenda) {
                    for (var i = users.length - 1; i >= 0; i--) {
                        if (users[i].id === sharedAgenda.userId && sharedAgenda.agendaId === currentAgendaId) {
                            users.splice(i, 1);
                        }
                    }
                });

                // remove the selected client from list (can't assign agenda to himself)
                for (var i = users.length - 1; i >= 0; i--) {
                    if (users[i].id === SharedAgendaService.currentUser().id) {
                        users.splice(i, 1);
                    }
                }

                return users;
            }

            function refreshReleasedAgendas() {
                // in released view ("gedeeld met"): refresh shared agendas, because the shared agendas should always be up to date (and it's users)
                if (scope.vm.sharedAgendaDto.isReleasedView) {
                    return RightConfigurationService.getReleasedAgendas(SharedAgendaService.currentUser().id)
                                .then(function(sharedAgendaDto) {
                                    scope.vm.sharedAgendaDto = sharedAgendaDto;
                                    scope.vm.overview.init(sharedAgendaDto.sharedAgendas);
                                });
                }
            }
        }
    }
})();